import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '@/lib/supabase';
import ProjectSelector from '@/components/Projects/ProjectSelector';
import NewProjectModal from '@/components/Projects/NewProjectModal';
import GitHubImportModal from '@/components/Projects/GitHubImportModal';
import EditorV2 from '@/components/Editor/EditorV2';
import { User } from '@shared/types';

export default function MainPage({ user }: { user: User }) {
  const [isNewProjectOpen, setIsNewProjectOpen] = useState(false);
  const [isGitHubImportOpen, setIsGitHubImportOpen] = useState(false);
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await supabase.auth.signOut();
      navigate('/login');
    } catch (error) {
      console.error('Sign out error:', error);
    }
  };

  const goToAdmin = () => {
    navigate('/admin');
  };

  return (
    <div className="h-screen w-screen flex flex-col bg-background">
      {/* Header */}
      <div className="h-12 bg-card border-b flex items-center px-4 shrink-0 gap-4">
        <h1 className="text-lg font-semibold text-primary">Uncommonable</h1>

        <ProjectSelector
          onNewProject={() => setIsNewProjectOpen(true)}
          onGitHubImport={() => setIsGitHubImportOpen(true)}
        />

        <div className="ml-auto flex items-center gap-3">
          {user.is_super_user && (
            <button
              onClick={goToAdmin}
              className="px-3 py-1.5 text-xs bg-purple-600 text-white rounded-md hover:bg-purple-700 transition-colors"
            >
              Admin Panel
            </button>
          )}
          <button
            onClick={handleSignOut}
            className="px-3 py-1.5 text-xs bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
          >
            Sign Out
          </button>
        </div>
      </div>

      {/* New Project Modal */}
      <NewProjectModal
        isOpen={isNewProjectOpen}
        onClose={() => setIsNewProjectOpen(false)}
      />

      {/* GitHub Import Modal */}
      <GitHubImportModal
        isOpen={isGitHubImportOpen}
        onClose={() => setIsGitHubImportOpen(false)}
      />

      {/* IDE Content */}
      <div className="flex-1 overflow-hidden">
        <EditorV2 />
      </div>

      {/* Status Bar */}
      <div className="h-6 bg-primary text-primary-foreground text-xs flex items-center px-4 shrink-0">
        <span>Ready</span>
        <span className="ml-auto">Uncommonable v2.0</span>
      </div>
    </div>
  );
}
